// extracted by mini-css-extract-plugin
export default {"red":"styles_red__lZzKk","green":"styles_green__xhthX"};